export interface ITermsAndConditionsPayload {
    agreedTermsAndConditions: boolean;
}

export const getStateToPayload = (privacyPolicyValue: boolean): ITermsAndConditionsPayload => ({
    agreedTermsAndConditions: privacyPolicyValue,
});
